import { useQuery } from '@tanstack/react-query';

import getGiveawayById from 'Api/brief-live/getGiveawayById';

import getGiveawayByIdResponse from './model/response/getGiveawayByIdResponse';

const useGetGiveawayById = (id) => {
  return useQuery({
    queryKey: ['giveaway-by-id', id],
    queryFn: async () => {
      const response = await getGiveawayById(id);

      return getGiveawayByIdResponse(response);
    },
    
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export default useGetGiveawayById;
